export default "__VITE_ASSET__C$AOuA5I__"